import { useCallback } from "react";
import { Textarea } from "@/components/ui/textarea";
import { slotRegistry, type SlotEditorProps } from "../slot_registry.js";

const MAX_LENGTH = 300;

function MicropostSlotEditor({ content, update }: SlotEditorProps) {
  const text = new TextDecoder().decode(content);
  const charCount = text.length;
  const isOverLimit = charCount > MAX_LENGTH;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newContent = new TextEncoder().encode(e.target.value);
      update(newContent);
    },
    [update],
  );

  return (
    <div className="space-y-1">
      <Textarea
        value={text}
        onChange={handleChange}
        placeholder="What's happening?"
        rows={3}
        className="w-full resize-none"
      />
      <div
        className={`text-right text-xs ${isOverLimit ? "text-destructive" : "text-muted-foreground"}`}
      >
        {charCount}/{MAX_LENGTH}
      </div>
    </div>
  );
}

slotRegistry.register({
  type: "micropost",
  component: MicropostSlotEditor,
});
